import React, { useEffect, useState } from 'react';
import { Spinner } from 'reactstrap';
import { getDashboardRightExercise } from '../../../../helpers/water_rights/backend_helper';
import EChartsStackedHorizontalBarChart from '../../../../Components/Common/Charts/ECharts/EChartsStackedHorizontalBarChart';
import { generateColorGradient } from '../../../../Components/Hooks/useColorArrayHooks';

const WaterRightsExerciseChart = () => {
	const [data, setData] = useState(null);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		let cancelled = false;
		getDashboardRightExercise()
			.then(res => { if (!cancelled) setData(res); })
			.catch(() => {})
			.finally(() => { if (!cancelled) setIsLoading(false); });
		return () => { cancelled = true; };
	}, []);

	if (isLoading) {
		return <div className='d-flex justify-content-center align-items-center py-4'><Spinner size='sm' /></div>;
	}

	const series = data?.series || [];
	const yCategories = data?.establishment_types || [];

	if (!series.length) {
		return <div className='d-flex flex-column align-items-center justify-content-center text-muted py-4 h-100'><p className='mb-0'>Sin datos disponibles</p></div>;
	}

	return (
		<EChartsStackedHorizontalBarChart
			series={series}
			yAxisCategories={yCategories}
			colors={generateColorGradient(series.length || 1)}
			height='250px'
		/>
	);
};

export default WaterRightsExerciseChart;
